import React, { useState, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";

import Loading from "../../Others/Loading";
import toast from "react-hot-toast";
import {
  cancelOrder,
  fetchOrderDetails,
  fetchStoreOrderDetails,
} from "../../Request/OrderRequests";
import { useSelector } from "react-redux";

import SearchIcon from "../../img/search-icon.png";
import backIcon from "../../img/Arrow.png";
import bagIcon from "../../img/bagIcon2.png";
import rashanLogo from "../../img/LOGO.svg";
import "./index.css";
import OrderStatusCard from "./Components/OrderStatusCard";
import OrderCarousel from "./Components/OrderCarousel";

export const mintuesPassed = (orderDate) => {
  const diff = Math.abs(new Date().getTime() - new Date(orderDate).getTime());
  return Math.floor(diff / 1000 / 60);
};

function strfDate(date) {
  let dates = new Date(date).toDateString().slice(0, 10);
  let year = new Date(date).toDateString().slice(10, 15);
  let time = new Date(date).toLocaleTimeString();
  return dates + ", " + year + ", " + time;
}

const OrdersStatus = ({ titleBarRef }) => {
  const [order, setOrder] = useState(null);
  const order_id = useParams()?.id;
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const cancelReasons = [
    "Placed order by mistake.",
    "Got better price elsewhere.",
    "Delivery time is too long.",
    "Change delivery address/phone number.",
    "Others",
  ];
  const [otherReason, setOther] = useState("");
  const name = useSelector((u) => u.user.info?.name);
  const userAddress = useSelector((state) => state.user?.address);

  const primaryAddress = useMemo(
    () =>
      userAddress?.filter((address) => {
        if (address.primary) {
          return address;
        }
      }),
    [userAddress]
  );
  useEffect(() => {
    if (order_id) {
      fetchOrderDetails(order_id)
        .then((res) => {
          if (!res?.order.length || !res?.suborder?.length) {
            fetchStoreOrderDetails(order_id).then((backupres) => {
              setOrder(backupres);
            });
            return;
          }
          setOrder(res);
        })
        .catch((err) => console.log(err));
    }
  }, [order_id]);

  //-----------------------------MAIN JSX RETURN---------------------------------------
  return (
    <>
      {order ? (
        <>
          {/************************** Track Order Start *************************/}

          <div className="ot1">
            <div>
              <div
                ref={titleBarRef}
                className="ot2 fixed-top d-flex align-items-center transition text-orange bg-white "
              >
                <div className="text-center my-auto ot3">
                  <img
                    src={backIcon}
                    alt=""
                    width={24}
                    onClick={() => navigate(-1)}
                  />
                </div>
                <div className="w-100 my-auto overflow-hidden">
                  <h2 className="ot4">#RP{order?.order?.[0]?.order_id}</h2>
                  <h5 className="ot5">Rashan Point, Bahadurgarh</h5>
                </div>
                <div className="ot6 text-center d-flex justify-content-evenly my-auto ms-auto ">
                  <img
                    src={SearchIcon}
                    alt=""
                    width={22}
                    className="d-block"
                    onClick={() => navigate(`/search`)}
                  />
                </div>
              </div>
              <div className="ot7 d-flex align-items-center transition bg-white fixed-top ">
                <div className="w-100 my-auto overflow-hidden ot8">
                  <h2 className="ot9">
                    {order?.order?.[0]?.status === "Cancelled"
                      ? "Order Cancelled"
                      : `Arriving in: ${
                          90 - mintuesPassed(order?.order[0]?.orderDate)
                        } mins`}
                  </h2>
                  {primaryAddress && (
                    <h5 className="ot10">
                      Delivering to: {primaryAddress[0]?.area},{" "}
                      {primaryAddress[0]?.city}, {primaryAddress[0]?.address}{" "}
                      ...
                    </h5>
                  )}
                </div>
              </div>

              {order?.order?.[0]?.status === "Cancelled" ? (
                <div className="card-wrap ot11">
                  <span className="text-muted fw-bold">
                    Cancelled on {strfDate(order?.order?.[0]?.["statusDate"])}
                  </span>
                </div>
              ) : (
                <OrderStatusCard
                  mintuesPassed={mintuesPassed(order?.order[0]?.orderDate)}
                  orderStatus={order?.order?.[0]?.status}
                />
              )}

              <div className="card-wrap ot14">
                <div
                  className="d-flex align-items-center sec-title"
                  style={{ marginBottom: "16px" }}
                >
                  <img
                    src={bagIcon}
                    alt="titleImg"
                    style={{
                      width: "18px",
                      minWidth: "18px",
                      marginRight: "12px",
                    }}
                  />
                  <h2 style={{ margin: "0" }}>Order Summary</h2>
                </div>
                <ul className="billSummaryList">
                  <li style={{ fontWeight: "600" }}>
                    Item Total: 5{" "}
                    <div className="badge badge-success ot15">
                      ₹
                      {order?.order?.[0]?.product_discount?.toLocaleString(
                        "en-IN"
                      ) || 0}
                    </div>
                    {/* NAVIGATE TO SEE ALL ITEMS */}
                    <div
                      className="ms-auto ot16"
                      onClick={() =>
                        navigate(`/placedorderdetails/${order_id}`)
                      }
                    >
                      See all items
                    </div>
                  </li>
                </ul>

                {/* CANCEL ORDER */}
                {/* {order?.order?.[0]?.status === "Cancelled" ? null : (
                  <div className="d-flex align-items-center ot17">
                    <div className="d-flex align-items-center"></div>
                    <div
                      className="ms-auto ot18"
                      data-bs-toggle="modal"
                      data-bs-target="#cancelOrderModal"
                    >
                      Canel Order
                    </div>
                  </div>
                )} */}
              </div>

              {/************************** Modal Start ********************************/}
              <div
                className="modal fade custom-modal"
                id="cancelOrderModal"
                tabIndex="-1"
                aria-labelledby="cancelOrderTitel"
                aria-hidden="true"
              >
                <div className="modal-dialog  modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body p-0">
                      <h5 className="modal-title" id="cancelOrderTitel">
                        Are you sure want to Cancel
                        <br />
                        the Order?
                      </h5>
                      <div className="d-flex justify-content-stretch">
                        <button
                          type="button"
                          className="btn flex-fill btn-outline-secondary"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <div style={{ width: "16px" }}></div>
                        <button
                          type="button"
                          className="btn flex-fill btn-outline-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setLoad(true);
                            cancelOrder({
                              orderId: order_id,
                              cancelReason: cancelReasons[4],
                              otherReason: otherReason,
                              name,
                            })
                              .then(() => {
                                toast.success("Order cancelled");
                                fetchOrderDetails(order_id)
                                  .then((res) => setOrder(res))
                                  .catch((err) => console.log(err))
                                  .finally(() => {
                                    setLoad(false);
                                    // closeRef.current.click();
                                    navigate("/account", { replace: true });
                                  });
                              })
                              .catch((err) => {
                                console.log(err);
                                setLoad(false);
                              });
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/************************** Modal End ********************************/}
            </div>
            <OrderCarousel />
          </div>
        </>
      ) : (
        <Loading text="Getting order info" />
      )}
    </>
  );
};

export default OrdersStatus;
